<template>
  <div v-if="plansList?.length" class="plans-list">
    <div
      v-if="todayList && todayList.plans?.length"
      class="first-plans"
      :style="{ backgroundImage: `url('${followUpBg}')` }"
    >
      <div class="date">
        {{ todayList.statDate }}
        <span>{{ todayList.statWeek }}</span>
      </div>
      <div class="plan-item-wrap">
        <PlanItem v-for="(plan, index) in todayList.plans" :key="index" :plan-info="plan" :profile-id="profileId" />
      </div>
    </div>
    <div v-if="otherDayList?.length" class="other-plans-wrap">
      <div v-for="(item, ind) in otherDayList" :key="ind" class="other-plans">
        <img class="date-dot" :src="followUpBlueDot" alt="" />
        <div class="date">{{ item.statDate }}{{ item.statWeek }}</div>
        <div class="plan-item-wrap">
          <PlanItem v-for="(plan, index) in item.plans" :key="index" :plan-info="plan" :profile-id="profileId" />
        </div>
      </div>
    </div>
  </div>
  <div v-else class="plans-list-empty">
    <EmptyStatus />
  </div>
</template>

<script setup lang="ts">
import { PlanDataInfo } from '@tencent/fd-types/patient';
import PlanItem from '../widget/PlanItem.vue';
import { useFollowUpStore } from '@/store/modules/followUp';
import followUpBg from '@/assets/images/follow-up-bg.png';
import followUpBlueDot from '@/assets/images/follow-up-blue-dot.png';
import EmptyStatus from '@/views/widget/emptyStatus.vue';

const followUpStore = useFollowUpStore();

const props = withDefaults(defineProps<{ profileId: string; type: string }>(), {
  profileId: '',
  type: '',
});
const { profileId, type } = toRefs(props);
const plansList = ref<PlanDataInfo[]>([]);

const todayList = computed(() => {
  return plansList.value.find((p) => p.isToday);
});

const otherDayList = computed(() => {
  return plansList.value.filter((p) => !p.isToday);
});

const queryFollowUpPlanList = async () => {
  plansList.value = await followUpStore.getFollowUpPlanList({ profileId: profileId.value, type: type.value });
};

defineExpose({
  queryFollowUpPlanList,
});
watch([type, profileId], async (val) => {
  if (profileId.value) {
    queryFollowUpPlanList();
  }
});
</script>

<style scoped lang="less">
.plans-list {
  position: relative;

  .first-plans {
    margin: auto;
    padding: 78px 16px 1px;
    border-radius: 4px;
    width: 702px;
    background-color: #cce3ff;
    background-repeat: no-repeat;
    background-position: 0 0;
    background-size: contain;

    .date {
      margin-bottom: 16px;
      text-align: left;
      font-weight: 500;
      font-size: 28px;
      color: #004699;
    }
  }

  .other-plans-wrap {
    margin: auto;
    border-left: 2px dashed #9ecbff;
    width: 702px;

    .other-plans {
      position: relative;
      margin-left: 21px;
      margin-top: 40px;
      width: 681px;

      .date-dot {
        position: absolute;
        left: -30px;
        border-radius: 7px;
        width: 14px;
        height: 14px;
        background-color: #0d7cff;
      }

      .date {
        margin-bottom: 16px;
        height: 32px;
        line-height: 22px;
        text-align: left;
        font-weight: 500;
        font-size: 28px;
        color: #16181a;
      }
    }
  }
}

.plans-list-empty {
  padding-top: 250px;
}
</style>
